import { EditorState } from 'prosemirror-state'
import { Decoration, DecorationSet } from 'prosemirror-view'

import { isManualBreak } from '#util/pagination/helpers'

import { pageHeaderWidget } from '../page-decoration'

export const buildManualDecorations = (
  editorState: EditorState,
): DecorationSet => {
  const decorations: Decoration[] = []
  editorState.doc.descendants((n, pos) => {
    if (isManualBreak(n)) {
      decorations.push(pageHeaderWidget(pos, {}, { isManualBreak: true }))
    }
  })

  return DecorationSet.create(editorState.doc, decorations)
}
